import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import {
  PhFiltersAction,
  PhFiltersDataEmitter,
  PhFiltersService,
} from '@shared/components/ph-filters/ph-filters.service';
import { FiltersParams } from '@shared/models/filters/filters-params.model';
import { ActivatedRoute } from '@angular/router';
import { AbstractSortProjectsComponent } from './abstract-sort-projects.component';

@Component({
  selector: 'app-sort-projects',
  templateUrl: './sort-projects.component.html',
  styleUrls: ['./sort-projects.component.scss'],
})
export class SortProjectsComponent extends AbstractSortProjectsComponent implements OnInit {
  constructor(
    public filtersService: PhFiltersService,
    protected activatedRoute: ActivatedRoute,
    protected _cdr: ChangeDetectorRef
  ) {
    super(activatedRoute, _cdr);
  }

  ngOnInit(): void {
    super.ngOnInit();
  }

  checkUrlParams(): void {
    const params: FiltersParams = this.filtersService.params;
    if (this.s && params.order_by) {
      this.s.patchValue(params.order_by, { emitEvent: false });
    }
  }

  updateParams(): void {
    this.filtersService.filtersEmitter.emit(
      new PhFiltersDataEmitter({
        action: PhFiltersAction.UPDATE_PARAMS,
        params: {
          order_by: this.s.value,
        },
      })
    );
  }
}
